import React from 'react';
import { IconProps } from '../IconProps';

export const FolderIcon: React.FC<IconProps> = ({
	width = 32,
	height = 32,
	fill = '#0045db',
	className,
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill={fill}
			aria-hidden="true"
			className={className}
		>
			<path d="M10 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2z" />
		</svg>
	);
};
